import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import style from './style.m.less'

const LanguageMenu: FC = () => {
    const { i18n } = useTranslation()
    const navigate = useNavigate()

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng).then(() => navigate(0))
    }
    /*
    const menuLanguages = (
        <Menu className={style.menu}>
            {languages.map((lng) => {
                const isActive = i18n.language.includes(lng.value)

                return (
                    <Menu.Item key={lng.id}>
                        <div
                            className={isActive ? style.subLinkActive : style.subLink}
                            onClick={() => changeLanguage(lng.value)}
                        >
                            {lng.label}
                        </div>
                    </Menu.Item>
                )
            })}
        </Menu>
    )
     */

    const currentLabel = i18n.language.includes('ru') ? 'EN' : 'RU'
    const nextLanguage = i18n.language.includes('ru') ? 'en' : 'ru'

    return (
        <div
            className={currentLabel === 'RU' ? style.navLinkActive : style.navLink}
            style={{
                lineHeight: '1em',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                width: 'auto',
            }}
            onClick={() => changeLanguage(nextLanguage)}
        >
            {currentLabel}
        </div>
    )
}

export default LanguageMenu
